import { Component, inject, OnInit, signal, ChangeDetectionStrategy } from '@angular/core';
import { TitleChange } from '../services/title-change';
import { Link } from "../directives/link";

@Component({
  selector: 'app-bc-ad',
  imports: [Link],
  templateUrl: './bc-ad.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './bc-ad.scss',
})
export class BcAd implements OnInit{
  dynamicTitle = inject(TitleChange);
  
  constructor() {
    this.dynamicTitle.title(`Calendar`);
    this.dynamicTitle.description(`The calendar is a human invention that has been adapted and changed over time for various purposes.`);
  }

  private calendars = ["buddhist","chinese","coptic","dangi","ethiopic","hebrew","indian","islamic","japanese","persian","roc"];

  dateList = signal([] as string[]);

  updateDates = () => {
    const d = Date.now();
    let itnlWorks: boolean = false;
    try {
      this.dateList.set([...this.calendars.map((calendar) => {
        const intl = new Intl.DateTimeFormat(`en-GB-u-ca-${calendar}`, { day: 'numeric', month: 'long', year: 'numeric' });
        return `${calendar.charAt(0).toUpperCase().concat(calendar.substring(1))}: ${intl.format(d)}`;
      })].sort());
    } catch {
      this.dateList.set([...this.calendars]);
    }
  }

  ngOnInit(): void {
    this.updateDates();
  }
}
